import { render, staticRenderFns } from "./AdminLayout.vue?vue&type=template&id=21809867&"
import script from "./adminLayout.js?vue&type=script&lang=js&"
export * from "./adminLayout.js?vue&type=script&lang=js&"
import style0 from "./AdminLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports